export class EcdRoutes {
    public static readonly ECDRoot: string = 'ecd';

    public static readonly Clergy: string = 'clergy';    

    public static readonly Parish: string = 'institution';    

    public static readonly Search: string = 'search';    

    public static readonly AdvancedSearch: string = 'advanced_search';    

    public static readonly Results: string = 'results';    

    public static readonly Detail: string = 'detail';    

    public static readonly Mail: string = 'mail';    
}